import React, { useEffect, useState, useCallback } from "react";
import { ModalProps } from "../../../interfaces/modal";
import { useCrmStore } from "../../../stores/crm";
import {
  deleteMission,
  handleDeleteCustomerFile,
} from "../../../api/customerFile";
import { showToastError, showToastSuccess } from "../../../services/toast";
import { useStaffStore } from "../../../stores/staff";
import { deleteEvent } from "../../../api/events";
import { useInvoiceStore } from "../../../stores/invoice";
import { deleteProforma } from "../../../api/invoices";
import { deleteCreditNote } from "../../../api/creditNotes";
import { usePaymentStore } from "../../../stores/payment";
import { deletePayment, deletePaymentDifference } from "../../../api/payments";
import { deleteRefund } from "../../../api/reimboursement";
import { useSocialStore } from "../../../stores/social";
import {
  deleteAbsence,
  deleteEmployee,
  deleteValeur,
} from "../../../api/social";
import { deleteUser } from "../../../api/users";
import { deleteInvoiceTemplate } from "../../../api/invoicesTemplates";
import { useSettingsStore } from "../../../stores/settings";
import { deleteJobOpening } from "../../../api/jobsOpenings";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "./ModalShell";

const getDeleteText = (
  location: string,
  tabCRM: string,
  tabStaff: string,
  tabInvoice: string,
  tabPayment: string,
  tabSocial: string,
  tabElements: string,
  tabSettings: string,
  reimboursementId?: string
) => {
  if (location === "/crm") {
    if (tabCRM === "Dossier clients") return "le client";
    if (tabCRM === "Missions") return "la mission";
    if (tabCRM === "Documents") return "le document";
  } else if (location === "/staff") {
    if (tabStaff === "Utilisateurs") return "l'utilisateur";
    if (tabStaff === "Évènements") return "l'évènement";
  } else if (location === "/invoices") {
    if (tabInvoice === "Proformas") return "la proforma";
    if (tabInvoice === "Avoirs") return "l'avoir";
  } else if (location === "/payments") {
    if (tabPayment === "Encaissements" && !reimboursementId)
      return "l'encaissement";
    if (tabPayment === "Encaissements" && reimboursementId)
      return "le remboursement";
    if (tabPayment === "PaymentDifferences") return "l'écart de réglement";
  } else if (location === "/social") {
    if (tabSocial === "Salariés") return "le salarié";
    if (tabElements === "Absences") return "l'absence";
    if (tabElements === "Valeurs") return "la valeur";
    if (tabElements === "Bulletins") return "le bulletin";
  } else if (location === "/settings") {
    if (tabSettings === "Templates") return "le template de facture";
    if (tabSettings === "Recrutement") return "l'offre d'emploi";
  }
  return "l'élément";
};

const getDeleteAction = ({ 
  location,
  tabCRM,
  tabStaff,
  tabInvoice,
  tabPayment,
  tabSocial,
  tabElements,
  tabSettings,
  id,
  idCustomer,
  reimboursementId,
  setUpdateCrm,
  updateCrm,
  setUpdateStaff,
  updateStaff,
  setUpdateProforma,
  updateProforma,
  setIdsProformasSelected,
  setUpdatePaymentBool,
  updatePaymentBool,
  setUpdateSocial,
  updateSocial,
  setUpdateSettings,
  updateSettings,
}: {
  location: string;
  tabCRM: string;
  tabStaff: string;
  tabInvoice: string;
  tabPayment: string;
  tabSocial: string;
  tabElements: string;
  tabSettings: string;
  id?: string;
  idCustomer?: string;
  reimboursementId?: string;
  setUpdateCrm: (v: boolean) => void;
  updateCrm: boolean;
  setUpdateStaff: (v: boolean) => void;
  updateStaff: boolean;
  setUpdateProforma: (v: boolean) => void;
  updateProforma: boolean;
  setIdsProformasSelected: (v: any[]) => void;
  setUpdatePaymentBool: (v: boolean) => void;
  updatePaymentBool: boolean;
  setUpdateSocial: (v: boolean) => void;
  updateSocial: boolean;
  setUpdateSettings: (v: boolean) => void;
  updateSettings: boolean;
}) => {
  if (location === "/crm") {
    if (tabCRM === "Dossier clients" && id) {
      return () =>
        handleDeleteCustomerFile(Number(id)).then(() => {
          showToastSuccess("Le client a bien été supprimé");
          setUpdateCrm(!updateCrm);
        });
    } else if (tabCRM === "Missions" && id && idCustomer) {
      return () =>
        deleteMission(Number(idCustomer), Number(id)).then(() => {
          showToastSuccess("La mission a bien été supprimée");
          setUpdateCrm(!updateCrm);
        });
    } else if (tabCRM === "Documents") {
      return () => Promise.resolve(console.log("Suppression du document"));
    }
  } else if (location === "/staff") {
    if (tabStaff === "Utilisateurs") {
      return () =>
        deleteUser(Number(id)).then(() => {
          showToastSuccess("L'utilisateur a bien été supprimé");
          setUpdateStaff(!updateStaff);
        });
    } else if (tabStaff === "Évènements" && id) {
      return () =>
        deleteEvent(Number(id)).then(() => {
          showToastSuccess("L'évènement a bien été supprimé");
          setUpdateStaff(!updateStaff);
        });
    }
  } else if (location === "/invoices") {
    if (tabInvoice === "Proformas" && id) {
      return () =>
        deleteProforma(Number(id)).then(() => {
          showToastSuccess("La proforma a bien été supprimée");
          setUpdateProforma(!updateProforma);
          setIdsProformasSelected([]);
        });
    } else if (tabInvoice === "Avoirs" && id) {
      return () =>
        deleteCreditNote(Number(id)).then(() => {
          showToastSuccess("L'avoir a bien été supprimé");
          setUpdateProforma(!updateProforma);
        });
    }
  } else if (location === "/payments") {
    if (tabPayment === "Encaissements" && id && !reimboursementId) {
      return () =>
        deletePayment(Number(id)).then(() => {
          showToastSuccess("L'encaissement a bien été supprimé");
          setUpdatePaymentBool(!updatePaymentBool);
        });
    } else if (tabPayment === "PaymentDifferences" && id) {
      return () =>
        deletePaymentDifference(Number(id)).then(() => {
          showToastSuccess("L'écart de réglement a bien été supprimé");
          setUpdatePaymentBool(!updatePaymentBool);
        });
    } else if (tabPayment === "Encaissements" && reimboursementId) {
      return () =>
        deleteRefund(Number(reimboursementId)).then(() => {
          showToastSuccess("Le remboursement a bien été supprimé");
          setUpdatePaymentBool(!updatePaymentBool);
        });
    }
  } else if (location.includes("/social")) {
    if (tabSocial === "Salariés" && id) {
      return () =>
        deleteEmployee(Number(id)).then(() => {
          showToastSuccess("Le salarié a bien été supprimé");
          setUpdateSocial(!updateSocial);
        });
    } else if (tabSocial === "Eléments" && tabElements === "Absences" && id) {
      return () =>
        deleteAbsence(Number(id)).then(() => {
          showToastSuccess("L'absence a bien été supprimée");
          setUpdateSocial(!updateSocial);
        });
    } else if (tabSocial === "Eléments" && tabElements === "Valeurs" && id) {
      return () =>
        deleteValeur(Number(id)).then(() => {
          showToastSuccess("La valeur a bien été supprimée");
          setUpdateSocial(!updateSocial);
        });
    } 
  } else if (location === "/settings") {
    if (tabSettings === "Templates" && id) {
      return () =>
        deleteInvoiceTemplate(Number(id)).then(() => {
          showToastSuccess("Le template de facture a bien été supprimé");
          setUpdateSettings(!updateSettings);
        });
    } else if (tabSettings === "Recrutement" && id) {
      return () =>
        deleteJobOpening(Number(id)).then(() => {
          showToastSuccess("L'offre d'emploi a bien été supprimée");
          setUpdateSettings(!updateSettings);
        });
    } 
  }
  return null;
};

const DeleteModal: React.FC<ModalProps> = ({
  closeModal,
  id,
  reimboursementId,
}) => {
  const { tabCRM, updateCrm, setUpdateCrm, idCustomer } = useCrmStore();
  const { tabStaff, setUpdateStaff, updateStaff } = useStaffStore();
  const {
    tabInvoice,
    updateProforma,
    setUpdateProforma,
    setIdsProformasSelected,
  } = useInvoiceStore();
  const { tabPayment, updatePaymentBool, setUpdatePaymentBool } =
    usePaymentStore();
  const { tabSocial, setUpdateSocial, updateSocial, tabElements } =
    useSocialStore();
  const { tabSettings, setUpdateSettings, updateSettings } = useSettingsStore();
  const location = window.location.pathname;

  const [text, setText] = useState<string>("");

  useEffect(() => {
    setText(
      getDeleteText(
        location,
        tabCRM,
        tabStaff,
        tabInvoice,
        tabPayment,
        tabSocial,
        tabElements,
        tabSettings,
        reimboursementId?.toString()
      )
    );
  }, [
    location,
    tabCRM,
    tabStaff,
    tabInvoice,
    tabPayment,
    tabSocial,
    reimboursementId,
  ]);

  const handleDelete = useCallback(() => {
    const action = getDeleteAction({
      location,
      tabCRM,
      tabStaff,
      tabInvoice,
      tabPayment,
      tabSettings,
      tabSocial,
      tabElements,
      id: id?.toString(),
      idCustomer: idCustomer?.toString(),
      reimboursementId: reimboursementId?.toString(),
      setUpdateCrm,
      updateCrm,
      setUpdateStaff,
      updateStaff,
      setUpdateProforma,
      updateProforma,
      setIdsProformasSelected,
      setUpdateSettings,
      updateSettings,
      setUpdatePaymentBool,
      updatePaymentBool,
      setUpdateSocial,
      updateSocial,
    });
    if (action) {
      action()
        .then(() => closeModal())
        .catch(() => {
          showToastError("Une erreur est survenue");
        });
    } else {
      showToastError("Action de suppression non supportée");
    }
  }, [
    location,
    tabCRM,
    tabStaff,
    tabInvoice,
    tabPayment,
    tabSocial,
    tabElements,
    tabSettings,
    id,
    idCustomer,
    reimboursementId,
    setUpdateCrm,
    updateCrm,
    setUpdateStaff,
    updateStaff,
    setUpdateProforma,
    updateProforma,
    setIdsProformasSelected,
    setUpdatePaymentBool,
    updatePaymentBool,
    setUpdateSocial,
    updateSocial,
    setUpdateSettings,
    updateSettings,
    closeModal,
  ]);

  return (
    <ModalShell
      title="Suppression"
      size="sm"
      onClose={closeModal}
      footer={
        <>
          <ModalButton variant="secondary" onClick={closeModal}>
            Annuler
          </ModalButton>
          <ModalButton variant="danger" onClick={handleDelete}>
            Supprimer
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        Etes-vous sûr de bien vouloir supprimer {text} ?
      </ModalConfirmText>
    </ModalShell>
  );
};

export default DeleteModal;